/**
 * Helper function to set the Shopify API key in the meta tag
 * This is required for the new App Bridge (March 2024+)
 * @param {string} apiKey - The Shopify API key
 */
export function setShopifyApiKey(apiKey) {
  if (!apiKey) {
    console.warn('Attempted to set empty API key');
    return;
  }

  // Update the meta tag
  const metaTag = document.getElementById('shopify-api-key-meta');
  if (metaTag) {
    metaTag.setAttribute('content', apiKey);
  } else {
    // If meta tag doesn't exist, create it
    const newMetaTag = document.createElement('meta');
    newMetaTag.setAttribute('name', 'shopify-api-key');
    newMetaTag.setAttribute('content', apiKey);
    newMetaTag.setAttribute('id', 'shopify-api-key-meta');
    document.head.insertBefore(newMetaTag, document.head.firstChild);
  }

  // eslint-disable-next-line no-console
  console.log('Shopify API key set successfully');
}

/**
 * Get the current API key from the meta tag
 * @returns {string|null} The API key or null if not set
 */
export function getShopifyApiKey() {
  const metaTag = document.getElementById('shopify-api-key-meta');
  return metaTag ? metaTag.getAttribute('content') : null;
}
